import { memo, useCallback } from 'react'
import { CustomChip } from '../../../../shared/ui/CustomChip/CustomChip'
import { camelToSentence } from '../../../../shared/lib/caseConverters/camelToSentence'
import {
	formatFilterValue
} from '../../../../shared/lib/formatFilterValue/formatFilterValue'
import {
	useAppDispatch
} from '../../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import Box from '@mui/material/Box'
import { useParams } from 'react-router-dom'
import { licenseEventsActions } from '../../model/slices/licenseEventsSlice'
import { fetchLicenseEvents } from '../../model/services/fetchLicenseEvents'

interface LicenseEventsFilterChipProps {
	filterKey: string
	filterValue: string
	licenseId: string
}

export const LicenseEventsFilterChip = memo(
	function LicenseEventsFilterChip(props: LicenseEventsFilterChipProps) {
		const { filterKey, filterValue, licenseId } = props

		const dispatch = useAppDispatch()
		const { licenseId: licIDFromParams } = useParams()

		const filterKeyConverted = camelToSentence(filterKey)
		const filterValueConverted = formatFilterValue(filterValue)

		const deleteFilter = useCallback(() => {
			dispatch(licenseEventsActions.removeFilter(filterKey))
			dispatch(licenseEventsActions.setPage(1))
			dispatch(fetchLicenseEvents(licIDFromParams ?? licenseId))
		}, [dispatch, filterKey, licIDFromParams, licenseId])

		return (
			<CustomChip onClick={deleteFilter} iconX>
				{`${filterKeyConverted}:`}
				<Box
					component="span"
					sx={{ fontWeight: 600, pl: '4px' }}
				>
					{filterValueConverted}
				</Box>
			</CustomChip>
		)
	})